import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import WhatsAppFab from "@/components/WhatsAppFab";
import { api, formatApiError } from "@/lib/api";
import { ArrowRight, EnvelopeSimple, CheckCircle } from "@phosphor-icons/react";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState("");

    async function submit(e) {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
        } catch (err) {
            setError(formatApiError(err, "No se pudo procesar la solicitud"));
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />
            <div className="flex-1 flex items-center justify-center px-6 py-16">
                <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
                    <div className="gf-card">
                        {!sent ? (
                            <>
                                <div className="micro-label mb-2">— Recuperación</div>
                                <h1 className="serif text-3xl mb-2">¿Olvidaste tu contraseña?</h1>
                                <p className="text-sm text-[var(--gf-text-secondary)] mb-8">
                                    Introduce tu email y te enviaremos un enlace para restablecerla.
                                </p>
                                <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
                                    <div>
                                        <label className="gf-label">Email</label>
                                        <input type="email" required className="gf-input" value={email}
                                            onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" autoComplete="email" />
                                    </div>
                                    {error && (
                                        <div className="text-sm text-[var(--gf-danger)] border-l-2 border-[var(--gf-danger)] pl-3 py-2 bg-red-50" data-testid="forgot-error">
                                            {error}
                                        </div>
                                    )}
                                    <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="forgot-submit">
                                        {loading ? "Enviando..." : "Enviar enlace"} <ArrowRight size={16} />
                                    </button>
                                </form>
                                <div className="mt-6 text-center text-sm">
                                    <Link to="/login" className="text-[var(--gf-text-secondary)] hover:text-[var(--gf-gold)]">
                                        ← Volver al login
                                    </Link>
                                </div>
                            </>
                        ) : (
                            <div className="text-center py-4" data-testid="forgot-sent">
                                <CheckCircle size={48} weight="light" className="mx-auto mb-4 text-[var(--gf-success)]" />
                                <h2 className="serif text-2xl mb-3">Enlace enviado</h2>
                                <p className="text-sm text-[var(--gf-text-secondary)] mb-6">
                                    Si <span className="mono">{email}</span> corresponde a una cuenta registrada,
                                    recibirás un enlace para restablecer tu contraseña en unos minutos.
                                </p>
                                <div className="text-xs text-[var(--gf-text-muted)] mb-6 border-t pt-4">
                                    El enlace caduca en 30 minutos. Revisa la carpeta de spam si no lo ves.
                                </div>
                                <Link to="/login" className="btn-outline w-full justify-center">
                                    Volver al login
                                </Link>
                            </div>
                        )}
                    </div>
                </motion.div>
            </div>
            <WhatsAppFab />
        </div>
    );
}
